const resource = {
    resource_identifier_in_use: 'Identyfikator API {{indicator}} jest już używany',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
